import React, { useEffect, useState } from 'react';
import components from '../../components'; // Adjust the import path as necessary
import ApiCall from '../../utils/Api';
import Web3 from "web3";
import contractABI from '../../utils/contractABI';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();
  const [counts,setcounts]=useState(null)
  const [ethPrice, setEthPrice] = useState(null);
  const [contract, setContract] = useState(null);
  const [isconnected, setisconnected] = useState();
  const [loading, setLoading] = useState(true);

  const [web3, setWeb3] = useState(null);

  const contractAddress = import.meta.env.VITE_APP_contractAddress; // Replace with your contract address
  const TDUcontractAddress=import.meta.env.VITE_APP_TDUcontractAddress
  
  // Check if user has permission to access Dashboard
  useEffect(() => {
    const currentRole = localStorage.getItem('role');
    
    // Only Admin role can access Dashboard
    if (currentRole !== 'Admin') {
      // Redirect based on role without showing error message
      if (currentRole === 'Fund Provider') {
        navigate('/admin-panel/ProviderProfile');
      } else if (currentRole === 'Fund Subscriber') {
        navigate('/admin-panel/BuyFundAssets');
      } else {
        navigate('/auth/Login');
      }
      return;
    }
  }, [navigate]);

  useEffect(() => {
    const getAllProviderRequest = async () => {
      setLoading(true);
      
      // Check if the current role should call the statistics API
      const currentRole = localStorage.getItem('role');
      
      // Only call statistics API for Admin role (Dashboard is Admin-only)
      if (currentRole !== 'Admin') {
        setcounts({
          totalConsumers: 0,
          totalProviders: 0,
          totalOwnerSplitAmount: 0,
          totalProviderSplitAmount: 0
        });
        setLoading(false);
        return;
      }
      
      try {
        let datafile = await ApiCall.SECURE_API.get(
          `/admin/dashboardStatistics`
        );
        console.log(
          "🚀 ~ Dashboard ~ getAllProviderRequest ~ data:",
          datafile
        );
        let newData = datafile.data.data;
        console.log("newData>>>", newData);
        // Handle the case where statistics might be an empty array
        if (newData && newData.length > 0) {
          setcounts(newData[0]);
        } else {
          // Set default values if no data
          setcounts({
            totalConsumers: 0,
            totalProviders: 0,
            totalOwnerSplitAmount: 0,
            totalProviderSplitAmount: 0
          });
        }
     
      } catch (error) {
        console.log("Error getting dashboard statistics:", error);
        // Set default values on error
        setcounts({
          totalConsumers: 0,
          totalProviders: 0,
          totalOwnerSplitAmount: 0,
          totalProviderSplitAmount: 0
        });

        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Failed to load dashboard statistics");
        }
      } finally {
        setLoading(false);
      }
    };
    getAllProviderRequest();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiCall.Api.get('/thirdPartyApi/getCryptoData');
        const ethereumData = response.data.data['1027'];
        // Extract the USD price from the API response
        const usdPrice = ethereumData.quote.USD.price;
        // Update the state with the USD price

        
        setEthPrice(usdPrice);
        // const exchangeRate = ethereumData.quote.USD.price;
        // const convertedUsdAmount = parseFloat(inputEthValue) * exchangeRate;
        // setUsdAmount(convertedUsdAmount.toFixed(2));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);
  const getPriceInUsd=(value) => {
    const exchangeRate = ethPrice;
            const convertedUsdAmount = parseFloat(value) * exchangeRate;
           return convertedUsdAmount.toFixed(6)
      }
      
  // Format ETH amount - amounts are stored as numbers in wei format
  // Convert from wei to ETH using web3 if available, otherwise divide by 10^18
  const formatEthAmount = (amount) => {
    if (!amount || amount === 0) {
      return '0.000000';
    }
    
    try {
      // Convert amount to string for web3.fromWei (it requires string input)
      const amountStr = typeof amount === 'string' ? amount : amount.toString();
      
      if (web3 && web3.utils) {
        // Use web3 to convert from wei to ETH
        const ethAmount = web3.utils.fromWei(amountStr, "ether");
        return parseFloat(ethAmount).toFixed(6);
      } else {
        // Fallback: divide by 10^18 if web3 is not available
        const amountNum = typeof amount === 'string' ? parseFloat(amount) : amount;
        const ethAmount = amountNum / Math.pow(10, 18);
        return ethAmount.toFixed(6);
      }
    } catch (e) {
      console.error('Error formatting ETH amount:', e);
      // Fallback: try direct division
      try {
        const amountNum = typeof amount === 'string' ? parseFloat(amount) : amount;
        const ethAmount = amountNum / Math.pow(10, 18);
        return ethAmount.toFixed(6);
      } catch (e2) {
        return '0.000000';
      }
    }
  }
      const initWeb3 = async () => {
        if (window.ethereum) {
          // Modern dapp browsers
          const web3Instance = new Web3(window.ethereum);
          try {
            // Request user approval to access their accounts
            await window.ethereum.enable();
            setWeb3(web3Instance);
            setisconnected(true);
            localStorage.setItem("web3Instance", JSON.stringify(web3Instance)); // Save web3 instance to local storage
          } catch (error) {
            // if (error?.response?.data?.message) {
            //            toast.error(error.response.data.message);
            //          } else {
            //            toast.error(error.message);
            //          }
            console.error(error);
          }
        } else if (window.web3) {
          // Legacy dapp browsers
          const web3Instance = new Web3(window.web3.currentProvider);
          setWeb3(web3Instance);
        } else {
          // Non-dapp browsers
          console.log("Please install MetaMask!");
        }
      };
      useEffect(() => {
        initWeb3();
      }, []);
      useEffect(() => {
        const initContract = async () => {
          try {
            const deployedContract = new web3.eth.Contract(
              contractABI,
              contractAddress
            );
            setContract(deployedContract);
    
            // localStorage.setItem(
            //   "deployedContract",
            //   JSON.stringify(deployedContract)
            // ); // Save web3 instance to local storage
          } catch (error) {
            console.log(error);
          }
        };
    
        if (web3) {
          initContract();
        }
      }, [web3]);
      console.log("Dashboard counts:", counts);
  
  if (loading) {
    return (
      <>
        <div style={{fontSize:30,fontWeight:"bold"}}>Dashboard</div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <div>Loading dashboard statistics...</div>
        </div>
      </>
    );
  }

  return (
   <> 
        <div style={{fontSize:30,fontWeight:"bold"}}>Dashboard</div>
   <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
      <components.Dashboard.DashboardCard title="Total Consumers" count={counts?.totalConsumers || 0} />
      <components.Dashboard.DashboardCard title="Total Providers" count={counts?.totalProviders || 0} />
      <components.Dashboard.DashboardCard 
        title="Admin Share" 
        count={`${formatEthAmount(counts?.totalOwnerSplitAmount || 0)} ETH`} 
      />
      <components.Dashboard.DashboardCard 
        title="Provider Share" 
        count={`${formatEthAmount(counts?.totalProviderSplitAmount || 0)} ETH`} 
      />


    </div>
    </>
  );
};

export default Dashboard;
